import React, { Component } from "react";
import { Spin, Modal } from "antd";
import ClinicListView from "./ClinicListView";
import {
  getClinicList,
  getSpecModules,
  activateSpecModule,
  deactivateSpecModule,
  activateIpdModule,
  updateUserFlags
} from "../../services";
import {
  showErrorNotification,
  strings,
  history,
  showSuccessNotification
} from "../../helpers";

export default class ClinicListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clinicList: [],
      isProcessing: false,
      totalRecords: 0,
      totalPage: 0,
      pageNo: 1,
      searchText: "",
      stateName: "",
      bankDetailsFilter: null,
      specModules: [],
      selectedSpecModuleFilter: "All",
      isHospital: false,
      selectedClinicModule: null,
      selectedClinicId: null,
      activateModule: undefined,
      featureFlags: [
        { id: "ipd_enabled", name: "IPD" },
        // { id: "packages_enabled", name: "Care Packages", userBased: true },
        { id: "surgery_enabled", name: "Surgeries" },
        { id: "abdm_enabled", name: "ABDM" }
      ],
      showHospitalModal: false,
      selectedFeatureFlag: null
    };
  }

  componentDidMount() {
    this.fetchClinicData();
    this.fetchSpecModules();
  }

  fetchSpecModules = () => {
    const { featureFlags } = this.state;
    getSpecModules().then(response => {
      if (response?.data?.data?.length > 0) {
        const { data } = response?.data;
        const specModules = [];
        data.map(obj => {
          specModules.push({
            id: obj.attributes.id,
            name: obj.attributes.name
          });
        });
        let allModules = specModules;
        // if (process.env.REACT_APP_ENVIRONMENT === "staging")
        allModules = [...allModules, ...featureFlags];

        // specModules.push({
        //   id: "ipd_enabled",
        //   name: "IPD"
        // });
        // specModules.push({
        //   id: "care_package_enabled",
        //   name: "Care Packages"
        // });
        // specModules.push({
        //   id: "surgery_enabled",
        //   name: "Surgeries"
        // });
        this.setState({ specModules: allModules });
      }
    });
  };

  /**
   * @function fetchClinicData
   * @description This function get clinics data
   */
  fetchClinicData = () => {
    // get value from state
    const {
      pageNo,
      searchText,
      stateName,
      bankDetailsFilter,
      selectedSpecModuleFilter,
      isHospital,
      selectedFeatureFlag
    } = this.state;
    // call api function

    this.setState({
      isProcessing: true
    });
    getClinicList(
      pageNo,
      searchText,
      stateName,
      bankDetailsFilter,
      selectedSpecModuleFilter,
      isHospital,
      selectedFeatureFlag
    )
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response.data.success) {
          const { clinics } = response.data.data;
          const { total_records } = response.data.data;
          const { total_pages } = response.data.data;
          this.setState({
            clinicList: clinics,
            totalRecords: total_records,
            totalPages: total_pages
          });
        } else {
          this.setState({
            clinicList: [],
            isProcessing: false,
            totalRecords: 0,
            totalPages: 0
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ clinicList: [], isProcessing: false });
      });
  };

  /**
   * @function onPageChange
   * @oaram page
   * @description This function get called on page change
   */
  onPageChange = page => {
    this.setState({ pageNo: page, clinicList: [] }, () => {
      this.fetchClinicData();
    });
  };

  /**
   * @function handleSearchText
   * @description This function get called when clicked on search icon
   */
  handleSearchText = e => {
    this.setState({ searchText: e.target.value });
  };
  /**
   * @function handleSearch
   * @description This function get called when clicked on pres button
   */
  handleSearch = () => {
    this.setState({ pageNo: 1, clinicList: [] }, () => {
      this.fetchClinicData();
    });
  };

  /**
   * @function handleStateChange
   * @description This function get called when clicked on search icon
   */
  handleStateChange = e => {
    this.setState({ stateName: e.target.value });
  };
  /**
   * @function  handleStateSearch
   * @description This function get called when clicked on press enter
   */
  handleStateSearch = () => {
    this.setState({ pageNo: 1, clinicList: [] }, () => {
      this.fetchClinicData();
    });
  };

  /**
   * @function  navigateToClinicDetails
   * @param "e","clinicId"
   * @description This function redirect the user to clinic-details
   */
  navigateToClinicDetails = (e, clinicId) => {
    e.preventDefault();
    history.push(`/clinics-details/${clinicId}/basic-details`);
  };

  handleBankDetailsFilter = value => {
    this.setState(
      { pageNo: 1, clinicList: [], bankDetailsFilter: value },
      () => {
        this.fetchClinicData();
      }
    );
  };

  isFeatureFlag = flag => {
    const { featureFlags } = this.state;
    let isFlag = false;
    const index = featureFlags.findIndex(fflag => fflag.id == flag);
    if (index !== -1) {
      isFlag = true;
    }
    return isFlag;
  };

  handleSelectSpecModuleClinic = (val, obj) => {
    this.setState(
      {
        pageNo: 1,
        clinicList: [],
        selectedSpecModuleFilter: this.isFeatureFlag(val) ? "All" : val,
        selectedFeatureFlag: this.isFeatureFlag(val) ? val : null
      },
      () => {
        this.fetchClinicData();
      }
    );
  };

  handleUpdateClinicModule = (val, optionObj, selectedClinic) => {
    // check if selected module id is already present in the clinic spec modules
    let specModuleFiltered = [];
    if (
      selectedClinic?.clinic_spec_modules &&
      selectedClinic?.clinic_spec_modules.length > 0
    ) {
      const clinicModules = selectedClinic?.clinic_spec_modules;
      specModuleFiltered = clinicModules.filter(obj => {
        if (obj.spec_module_id === val) return obj;
      });
    }

    this.setState({
      selectedClinicModule: optionObj?.props?.specObj,
      selectedClinicId: selectedClinic?.id,
      activateModule: specModuleFiltered.length == 0 ? false : true
    });
  };

  handleActivationConfirmation = record => {
    const {
      selectedClinicModule,
      selectedClinicId,
      activateModule,
      featureFlags
    } = this.state;
    const moduleIndex =
      selectedClinicModule && selectedClinicModule.id
        ? featureFlags.findIndex(item => item.id == selectedClinicModule.id)
        : -1;
    const userBasedIndex =
      selectedClinicModule && selectedClinicModule.id
        ? featureFlags.findIndex(
            item => item.id == selectedClinicModule.id && item.userBased
          )
        : -1;

    if (selectedClinicId && selectedClinicModule && moduleIndex == -1) {
      Modal.confirm({
        title: `${activateModule ? "Deactivate" : "Activate"} confirmation`,
        content: (
          <div>{`Are you sure you want to ${
            activateModule ? "deactivate" : "activate"
          } this spec module for this clinic?`}</div>
        ),
        onOk: () => {
          this.handleActivateClinicModule();
        }
      });
    } else if (moduleIndex != -1 && userBasedIndex != -1) {
      this.handleUpdateUserFlag(record);
    } else if (moduleIndex != -1) {
      this.handleToggleIPD();
    } else {
      showErrorNotification("Please select a module");
    }
  };

  handleUpdateUserFlag = record => {
    const { selectedClinicModule } = this.state;
    const params = {
      [selectedClinicModule.id]: true
    };
    this.setState({ isProcessing: true });
    updateUserFlags(params, record.user_id)
      .then(response => {
        if (response?.data?.success) {
          this.fetchClinicData();
          this.resetData();
          showSuccessNotification(
            `${selectedClinicModule.name} ${"activated"} successfully`
          );
        } else {
          showErrorNotification(strings.schedule.serverError);
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  handleToggleIPD = () => {
    const {
      selectedClinicModule,
      selectedClinicId,
      activateModule
    } = this.state;

    this.setState({ isProcessing: true });
    activateIpdModule(
      selectedClinicId,
      selectedClinicModule?.id,
      !activateModule
    ).then(response => {
      this.setState({ isProcessing: false });
      if (response?.data?.success) {
        this.fetchClinicData();
        this.resetData();
        showSuccessNotification(
          `${selectedClinicModule.name} ${
            activateModule ? "deactivated" : "activated"
          } successfully`
        );
      } else {
        showErrorNotification(strings.schedule.serverError);
      }
    });
  };

  handleActivateClinicModule = () => {
    const {
      selectedClinicModule,
      selectedClinicId,
      activateModule
    } = this.state;

    this.setState({ isProcessing: true });
    if (activateModule) {
      deactivateSpecModule(selectedClinicId, selectedClinicModule.id).then(
        response => {
          this.setState({ isProcessing: false });
          if (response?.data?.success) {
            this.fetchClinicData();
            this.resetData();
            showSuccessNotification("Spec module deactivated successfully");
          } else {
            showErrorNotification(strings.schedule.serverError);
          }
        }
      );
    } else {
      activateSpecModule(selectedClinicId, selectedClinicModule.id).then(
        response => {
          this.setState({ isProcessing: false });
          if (response?.data?.success) {
            this.fetchClinicData();
            this.resetData();
            showSuccessNotification("Spec module activated successfully");
          } else {
            showErrorNotification(strings.schedule.serverError);
          }
        }
      );
    }
  };

  resetData = () => {
    this.setState({
      activateModule: undefined,
      selectedClinicId: null,
      selectedClinicModule: undefined
    });
  };

  toggleHospitalModal = () => {
    this.setState({ showHospitalModal: !this.state.showHospitalModal });
  };

  handleMenuClick = ({ key }) => {
    if (key === "hospital") {
      this.toggleHospitalModal();
    }
  };

  onHospitalCheckboxChange = e => {
    const { checked } = e.target;
    this.setState({ isHospital: checked, pageNo: 1, clinicList: [] }, () => {
      this.fetchClinicData();
    });
  };

  render() {
    const {
      clinicList,
      isProcessing,
      totalRecords,
      totalPages,
      pageNo,
      searchText,
      stateName,
      bankDetailsFilter,
      specModules,
      selectedSpecModuleFilter,
      selectedClinicModule,
      activateModule,
      selectedClinicId,
      showHospitalModal,
      selectedFeatureFlag
    } = this.state;
    return (
      <Spin spinning={isProcessing}>
        <ClinicListView
          navigateToClinicDetails={this.navigateToClinicDetails}
          clinicList={clinicList}
          allRecords={totalRecords}
          allPages={totalPages}
          pageNo={pageNo}
          onPageChange={this.onPageChange}
          searchText={searchText}
          handleSearchText={this.handleSearchText}
          handleSearch={this.handleSearch}
          stateName={stateName}
          handleStateChange={this.handleStateChange}
          handleStateSearch={this.handleStateSearch}
          handleBankDetailsFilter={this.handleBankDetailsFilter}
          bankDetailsFilter={bankDetailsFilter}
          specModules={specModules}
          selectedSpecModuleFilter={selectedSpecModuleFilter}
          handleSelectSpecModuleClinic={this.handleSelectSpecModuleClinic}
          handleUpdateClinicModule={this.handleUpdateClinicModule}
          handleActivateClinicModule={this.handleActivateClinicModule}
          selectedClinicModule={selectedClinicModule}
          activateModule={activateModule}
          handleActivationConfirmation={this.handleActivationConfirmation}
          selectedClinicId={selectedClinicId}
          handleMenuClick={this.handleMenuClick}
          showHospitalModal={showHospitalModal}
          toggleHospitalModal={this.toggleHospitalModal}
          fetchClinicData={this.fetchClinicData}
          onHospitalCheckboxChange={this.onHospitalCheckboxChange}
          selectedFeatureFlag={selectedFeatureFlag}
        />
      </Spin>
    );
  }
}
